/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-17 15:16:10
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2020-10-15 14:44:33
 */
export * from './getSystemInfo'
export * from './getNetworkType'
